// src/components/DataTable.js
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import {
  flattenObject,
  getFinalKeySegment,
  snakeToTitle,
  castToFloatAndReducePrecision,
  openInNewTab,
  openAndGoTo,
} from "../utils";

import { columnOverrides } from "../labels";

const ReactionTable = ({ data, units }) => {
  // const prettifyColumnValue = (item) => {
  //   if (item === undefined) {
  //     return "";
  //   }
  //   //const newStr = JSON.stringify(item);
  //   const newStr = "" + item;
  //   if (newStr.length <= 23) {
  //     return newStr;
  //   } else {
  //     return newStr.slice(0, 10) + "..." + newStr.slice(newStr.length - 10);
  //   }
  // }

  // const flattenedData = data?.map((item) => flattenObject(item));
  // // Filter out keys that contain extra values
  // const tableData = flattenedData.map((item) => {
  //   let filteredItem = {};
  //   for (const key in item) {
  //     if (!key.includes('.dft_electronic_structure.') &&
  //       !key.includes('.dft_physical_structure.')) {
  //       const newKey = getFinalKeySegment(key);
  //       //if (!filteredItem[newKey]) {
  //       filteredItem[newKey] = castToFloatAndReducePrecision(item[key]);
  //       //}
  //     }
  //   }
  //   return filteredItem;
  // });

  // Extract the keys from the data array
  let keys = Array.from(
    new Set(data.reduce((acc, obj) => acc.concat(Object.keys(obj)), [])),
  );
  var exclusions = ["_id", "unique_id", "type", "system_name"];

  keys = keys.filter((key) => !exclusions.includes(key));

  // Set the pagination options
  const paginationOptions = {
    sizePerPage: 15, // Number of rows per page
    hideSizePerPage: true, // Hide the rows per page dropdown
  };

  // Create the columns array for the BootstrapTable component
  let columns = keys.map((key) => {
    if (units && units[key]) {
      return {
        dataField: key,
        text: snakeToTitle(key) + ` (${units[key]})`,
        sort: true,
      };
    } else if (key === "system_name") {
      // Add hyperlink to dedicated system page
      return {
        dataField: key,
        text: snakeToTitle(key),
        sort: true,
        //formatter: (cell, row, rowIndex, extraData) => (
        //  <div>
        //    <a href={"/adsorbed_states/" + row._id}> {cell} </a>
        //  </div>
        //),
      };
    } else {
      return {
        dataField: key,
        text: key in columnOverrides ? columnOverrides[key] : snakeToTitle(key),
        sort: true,
      };
    }
  });

  // let keyChildren = keys.map((key) => { return getFinalKeySegment(key) });
  // keyChildren = [...keyChildren].filter(distinctValue => distinctValue);
  // console.log('DataTable', keyChildren.join(','));

  if (columns.length === 0) {
    columns = [{ dataField: "empty", text: "Enter a search to show data." }];
  } else {
    // console.log('columns', columns);
    // console.log('data', data);
    // console.log('flattenedData', flattenedData);
    // console.log('tableData', tableData);
  }

  const rowClickHandler = {
    onClick: (e, row, rowIndex) => {
      let href = "/catalyst_path/" + row.unique_id;
      openAndGoTo(href);
    },
    // Open tab in background on middle click
    onAuxClick: (e, row, rowIndex) => {
      let href = "/catalyst_path/" + row.unique_id;
      openInNewTab(href);
    },
    onContextMenu: (e, row, rowIndex) => {
      e.preventDefault();
      let href = "/catalyst_path/" + row.unique_id;
      openInNewTab(href);
    },
    onMouseOver: (e, row, rowIndex) => {
      e.target.style.cursor = "pointer";
    },
  };

  return (
    <div>
      {data ? (
        <>
          <BootstrapTable
            keyField="unique_id"
            striped={true}
            data={data}
            columns={columns}
            rowEvents={rowClickHandler}
            hover={true}
            defaultSorted={[{ dataField: "catalyst_elements", order: "asc" }]} // TODO
            pagination={paginationFactory(paginationOptions)}
            wrapperClasses="table-responsive"
          />
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default ReactionTable;
